import { Box, BoxProps, Flex, forwardRef } from '@chakra-ui/react';
import { useVideo } from 'react-use';
import { PlayIcon } from 'ui-components/dist/PlayIcon';

export interface IVideoProps extends BoxProps {
  alt?: string;
  autoPlay?: boolean;
  className?: string;
  containerProps?: BoxProps;
  loop?: boolean;
  poster?: string;
  muted?: boolean;
  playbackrate?: number;
  showPlayIcon?: boolean;
  src: string;
}

const Video = forwardRef<IVideoProps, 'video'>(
  (
    {
      alt,
      autoPlay = false,
      containerProps,
      poster,
      showPlayIcon = true,
      loop,
      muted,
      playbackrate = 1.0,
      src,
      ...videoAttrs
    },
    ref,
  ) => {
    const [video, state, controls] = useVideo(
      <Box
        as="video"
        src={src}
        poster={poster}
        loop={loop}
        autoPlay={autoPlay}
        muted={muted} // some browsers block autoplay if not muted
        playbackrate={playbackrate}
        {...videoAttrs}
      >
        {alt}
      </Box>,
    );

    const handleClick = () => {
      if (!autoPlay) {
        if (state.paused) {
          controls.play();
        } else {
          controls.pause();
        }
      }
    };

    return (
      <Flex
        ref={ref}
        onClick={handleClick}
        as="button"
        position="relative"
        align="center"
        justify="center"
        {...containerProps}
      >
        {showPlayIcon && state.paused && (
          <PlayIcon
            color="white"
            boxSize="34px"
            aria-label="Play video"
            position="absolute"
          />
        )}
        {video}
      </Flex>
    );
  },
);

export default Video;
